export const emptyMetadata = {
  blocks: [],
  datatypes: [],
  scopes: [],
  typelists: [],
  synceventstates: [],
  scopelists: []
};

export const emptyMetadataInfo = { created: '', meta: { description: '', generated: '' } };
